import { FunctionComponent as F, useState  } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Stack,
  Typography } from "@mui/material";
import { useDispatch } from 'react-redux';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { SelectChangeEvent } from "@mui/material/Select";
import { IState } from "../../core/store/store";
import { OrderReminderFrequency } from "@protoplan/types";
import { updateOrderReminder } from "../../core/store/user/user.slice";
import { postOrderReminder as updateUserOrderReminder } from "../../core/http/user";
import { uk } from "date-fns/locale";

interface FrequencyOption
{
  value: OrderReminderFrequency,
  label: string
}

const OrderReminder: F = () =>
{
  const dispatch = useDispatch();

  const user = useSelector((state: IState) => state.user);

  const defaultReminderDate = new Date();
  defaultReminderDate.setDate(defaultReminderDate.getDate() + 1);

  const [reminderDate, setReminderDate] = useState(user.orderReminder.date ?
    new Date(user.orderReminder.date) :
    defaultReminderDate);

  let tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const handleReminderDateChange = (date: any | Date | number | string) =>
  {
    if(!date)
      date = new Date();

    if(date.getTime() <= tomorrow.getTime())
      date = tomorrow;

    setReminderDate(date);
    dispatch(updateOrderReminder({ date }));
    updateUserOrderReminder({ date });
  };

  const frequencyOptions: FrequencyOption[] = [
    { label: 'Weekly', value: OrderReminderFrequency.WEEKLY },
    { label: 'Fortnightly', value: OrderReminderFrequency.FORTNIGHTLY },
    { label: 'Every 4 weeks', value: OrderReminderFrequency.FOURWEEKLY },
    { label: 'Monthly', value: OrderReminderFrequency.MONTHLY }];

  const [reminderFrequency, setReminderFrequencyOption] = useState<FrequencyOption>(
    frequencyOptions.filter(o => o.value === user.orderReminder.frequency)[0]);

  const handleReminderFrequencyChange = (event: SelectChangeEvent<number>) =>
  {
    const frequency = event.target.value as OrderReminderFrequency;
    setReminderFrequencyOption({ value: frequency, label: event.target.name });
    dispatch(updateOrderReminder({ frequency }));
    updateUserOrderReminder({ frequency });
  };

  return(user.orderReminder.active ?
    <Stack spacing={2}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={(user.countryId === 2 || user.countryId === 61) ? undefined : uk}>
        <DatePicker
          label='Date of next reminder email'
          value={reminderDate}
          onChange={handleReminderDateChange}
          minDate={tomorrow}/>
      </LocalizationProvider>
      <Stack direction='row' spacing={1}>
        <Typography variant='body1' gutterBottom>Frequency:</Typography>
        <Box>
          <FormControl>
            <Select
              SelectDisplayProps={{ style: {
                paddingTop: '3px',
                paddingBottom: '3px',
                paddingLeft: '9px',
                fontSize: 15 } }}
              // @ts-ignore
              value={reminderFrequency?.value || ''}
              onChange={handleReminderFrequencyChange}>
              {frequencyOptions.map((option, index) => <MenuItem
                key={index}
                dense={true}
                sx={{
                  pt: '3px',
                  pb: '3px',
                  pl: '9px' }}
                value={option.value}>{option.label}</MenuItem>)}
            </Select>
          </FormControl>
        </Box>
      </Stack>
    </Stack> :
    <></>);
};

export default OrderReminder